import { ThemeColors } from './token.types';

export const lightTheme = {
  // Surface colors
  colorNeutralBackground1: '#ffffff',
  colorNeutralBackground1Selected: '#e6f3ff',
  colorNeutralBackground1Hover: '#f5f5f5',
  colorNeutralBackground1Pressed: '#e0e0e0',
  colorNeutralBackground2: '#fafafa',
  colorNeutralBackground3: '#f5f5f5',
  colorNeutralBackground4: '#f0f0f0',
  colorNeutralBackground6: '#E6E6E6',

  // Text colors
  colorNeutralForeground1: '#242424',
  colorNeutralForeground1Disabled: '#bdbdbd',
  colorNeutralForeground2: '#424242',
  colorNeutralForeground3: '#616161',
  colorNeutralForegroundInverted: '#ffffff',
  colorNeutralForegroundStaticInverted: '#ffffff',
  colorNeutralGrey44: '#707070',

  // Border colors
  colorNeutralStroke1: '#d1d1d1',
  colorNeutralStroke1Disabled: '#f0f0f0',
  colorNeutralStroke2: '#e0e0e0',
  colorNeutralStrokeAccessible: '#616161',

  // Brand colors
  colorBrand60: '#4ba91f', // Very light brand color for subtle elements
  colorBrand70: '#389120', // Lighter brand color for hover states
  colorBrand80: '#26890D', // Primary brand color
  colorBrand90: '#1a5a0b', // Darker brand color for buttons/interactive elements
  colorBrand100: '#0f3006', // Very dark brand color for pressed states
  colorBrandShade10: '#21750B',
  colorBrandStroke: '#A2C993',

  colorGreenBackground: '#CEE3C5',
  colorGreenForeground: '#236911',
  colorGreenBorder: '#A2C993',
  colorBlueBackground: '#DEECF9',
  colorBlueForeground: '#0F6CBD',
  colorBlueBorder: '#9FCDEA',
  colorRedBackground: '#FDF3F4',
  colorRedForeground: '#B10E1C',
  colorRedBorder: '#EEACB2',
  colorDangerForeGround1: '#B10E1C',
  colorErrorForeground: '#BC2F32',
  colorYellowBackground: '#FFF4CE',
  colorYellowForeground: '#B87300',
  colorYellowBorder: '#FFB900',
  colorOrangeBackground: '#FFF9F5',
  colorOrangeForeground: '#8A3707',
  colorOrangeBorder: '#FDCFB4',
  colorMarigoldBackground: '#FEF7E6',
  colorMarigoldForeground: '#835b00',
  colorMarigoldBorder: '#F2D092',
  colorMarigoldForeground2: '#835B00',
  colorPinkBackground: '#f7c0e3',
  colorPinkForeground: '#80215d',
  colorPinkBorder: '#e43ba6',
  colorPurpleForeground: '#7840B8',
  colorPurpleBorder: '#7840B8',
  colorWarningBorder: '#FDCFB4',
  colorWarningForeground2: '#8A3707',

  // Badge specific colors
  colorNeutralBackground5: '#ebebeb',
  colorNeutralBackground3Pressed: '#d6d6d6',

  // Status colors
  colorPaletteGreenBackground3: '#54b054',
  colorPaletteYellowBackground3: '#f7d22a',
  colorPaletteRedBackground3: '#d74654',
  colorPaletteBlueBackground3: '#0078d4',

  //Category specific colors
  colorCalendar1: '#046a38',
  colorCalendar2: '#ba420b',
  colorCalendar3: '#005587',
  colorCalendar4: '#b51963',
  colorCalendar5: '#012169',
  colorCalendar6: '#896000',
  colorCalendar7: '#c50f1f',
  colorCalendar8: '#007680',
  colorCalendar9: '#424242',
  colorCalendarPurple: '#631db2',

  brandJewelGradient: 'linear-gradient(180deg, #1c3d26 0%, #046a38 100%)',

  // Spinner colors
  spinnerTrackColor: '#26890D',
  spinnerTailColor: '#A2C993',

  colorSuccessBackground1: '#DBFBD3',
  colorSuccessBorder1: '#7DF060',
  colorSuccessForeground1: '#21750B',

  colorBrandBackground2: '#CEE3C5',
  colorBrandForeground2: '#236911',

  colorNeutralForeground4: '#707070',

  warningForeground1: '#BC4B09',

  // Custom elements
  rulesDialogLinkColor: '#26890D',
  robinChatColor: '#26890d',
  refreshButton: '#1a5a0b',
  widgetCardHeaderDescription: '#605E5C',
  buttonDisabledColor: 'inherit',
  badgecountColor: '#616161',
  asterix: '#B10E1C',
} satisfies ThemeColors;
